module.exports = __webpack_public_path__ + "static/media/palms-events-top-left.997c46b0.png";